import { GET_HELP_CATEGORY_ARTICLES_REQUEST, GET_HELP_CATEGORY_ARTICLES_SUCCESS, GET_HELP_CATEGORY_ARTICLES_FAILURE, } from '../actions';
const initialState = {
    articles: {},
    isFetchingCategory: false,
};
const helpArticles = (state = initialState, action) => {
    switch (action.type) {
        case GET_HELP_CATEGORY_ARTICLES_REQUEST:
            return {
                ...state,
                isFetchingCategory: true,
            };
        case GET_HELP_CATEGORY_ARTICLES_SUCCESS: {
            const { categoryId } = action.extra;
            if (!categoryId) {
                return {
                    ...state,
                    isFetchingCategory: false,
                };
            }
            const compactArticles = action.payload
                .filter((article) => article.url)
                .map((article) => ({
                article_id: article.article_id,
                title: article.title,
                url: article.url,
            }));
            return {
                ...state,
                articles: {
                    ...state.articles,
                    [categoryId]: compactArticles,
                },
                isFetchingCategory: false,
            };
        }
        case GET_HELP_CATEGORY_ARTICLES_FAILURE:
            return {
                ...state,
                isFetchingCategory: false,
            };
        default:
            return state;
    }
};
export { helpArticles };
